const PMData = [
  {
    core: [
      {
        id: "1",
        name: "Familiarization to Product management",
        karma: "400",
        description:
          "In this Course you will be familiarized with “ What is product management ? “ and key terms related to it. ✨You will learn about the responsibilites and roles of a product manager, and different opportunities in Product management.",
        link: "https://www.udemy.com/course/product-management-a/",
        inner_description:
          "After course completion, post the screenshot of fully completed list of sessions from Udemy in #product-management channel of µLearn Discord server  with hashtag #product-intro to avail karma points.",
        example:
          " #product-intro Hey! I’ve completed Introduction to Product management course.",
      },
    ],
    sub: [
      {
        id: "1",
        name: "SWOT Analysis",
        karma: "200",
        description:
          "A SWOT analysis is designed to facilitate a realistic, fact-based, data-driven look at the strengths and weaknesses of an organization, initiatives, products within its industry. The organization needs to keep the analysis accurate by avoiding pre-conceived beliefs or gray areas and instead focusing on real-life contexts.",
        link: "https://youtu.be/mR9eICQJLXA",
        inner_description:
          "The above is a video on SWOT analysis of Starbucks. After having a good understanding of SWOT Analysis,  Prepare a SWOT analysis  for any of the following product companies Option 1 - Boat audio devices Option 2 - TATA motors EV Option 3 - Xioami MI India",
        example:
          "#product-swot-analysis Hey! I’ve completed SWOT analysis. Here is my analysis on \"topic\". ",
      },
    ],
  },
];

export default PMData;
